import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DistributionChannel } from '../../api/queries';
import { post } from '../../utils/networking';
import { GetDistributionChannelsCacheKey } from '../queries';

enum CreateNewDistributionChannelCacheKey {
  CreateNewDistributionChannel = 'CREATE_NEW_DISTRIBUTION_CHANNEL',
}

const createNewDistributionChannel = async (
  type: DistributionChannel['type'],
  webhookUrl: DistributionChannel['webhookUrl'],
  teamId: number,
) =>
  post(`/api/distribution-channels`, {
    type,
    webhookUrl,
    teamId,
  });

export const useCreateNewDistributionChannelMutation = (teamId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [
      CreateNewDistributionChannelCacheKey.CreateNewDistributionChannel,
      teamId,
    ],
    mutationFn: ({
      type,
      webhookUrl,
    }: {
      type: DistributionChannel['type'];
      webhookUrl: DistributionChannel['webhookUrl'];
    }) => createNewDistributionChannel(type, webhookUrl, teamId),

    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [
          GetDistributionChannelsCacheKey.GetDistributionChannels,
          teamId,
        ],
      }),
  });
};
